export function stringToArray(str: string): number[] {
	return str ? str.split(',').map(Number) : [];
}
